__webpack_require__.p = "/wp-content/themes/skapia/app/dist/";